import BenchlingConfig from 'BenchlingConfig';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import APIUtil from 'util/APIUtil';

const TYPES_WITH_VALUE_MESSAGING: Array<ModelTypeConstants> = [
  ModelTypeConstants.SEQUENCE,
  ModelTypeConstants.PROTEIN,
  ModelTypeConstants.ENTRY,
  ModelTypeConstants.PROTOCOL,
  ModelTypeConstants.BASIC_FOLDER_ITEM,
];
const CLONEABLE_TYPES: Array<ModelTypeConstants> = [
  ModelTypeConstants.SEQUENCE,
  ModelTypeConstants.PROTEIN,
  ModelTypeConstants.ENTRY,
  ModelTypeConstants.PROTOCOL,
];

export const showValueMessagingForSharedFile = (): boolean =>
  Boolean(
    !window.user &&
      window.bootstrap?.sharedFolderItemAPIId &&
      TYPES_WITH_VALUE_MESSAGING.includes(APIUtil.apiIdToType(window.bootstrap?.sharedFolderItemAPIId))
  );

export const showEditNowButtonForSharedFile = (): boolean =>
  Boolean(
    BenchlingConfig.GROWTH_ENABLE_CLONING_SHARED_FILES_INTO_NEW_ACCOUNT &&
      !window.user &&
      window.bootstrap?.sharedFolderItemAPIId &&
      CLONEABLE_TYPES.includes(APIUtil.apiIdToType(window.bootstrap?.sharedFolderItemAPIId))
  );
